const React = require('react-native');

const { StyleSheet, Dimensions, Platform } = React;

export default {
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  links: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 1,
    height: 65,
    borderColor: 'transparent',
  },

  logo: {
    alignSelf: 'stretch',
    resizeMode: 'cover',
    height: 120,
    //height: deviceHeight / 3.5,
    width: null,
    position: 'relative',
    marginBottom: 10,
  },
  badgeText: {
    fontSize: Platform.OS === 'ios' ? 13 : 11,
    fontWeight: '400',
    textAlign: 'center',
    marginTop: Platform.OS === 'android"' ? -3 : undefined,
  },
};
